<label class="portal-switch-toggle__container" (click)="onClick($event)">
  <input
    class="switch-input portal-switch-toggle__input"
    #input
    [disabled]="disabled"
    [id]="id"
    [ngModel]="isChecked"
    (change)="onCheckChange($event.target)"
    type="checkbox"
  />

  <span class="portal-switch-toggle__on">
    @if (size !== 'simple') {
      <span>{{ labelActive | portalTranslate }}</span>
    }
  </span>

  <span class="portal-switch-toggle__handle">
    @if (size === 'simple') {
      <i [ngClass]="'far ' + (isChecked ? 'fa-check' : '')"></i>
    }
  </span>

  <span class="portal-switch-toggle__off">
    @if (size !== 'simple') {
      <span>{{ labelInactive | portalTranslate }}</span>
    }
  </span>
</label>

@if (pending) {
  <span class="ms-2" @fadeInOutDelayed>
    <i class="far fa-circle-notch fa-spin"></i>
  </span>
}
